module.exports = __webpack_public_path__ + "static/img/exam-10-1-bg.a9c1006.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-10-1-bg.png
// module id = 3NRm
// module chunks = 1